import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from './context/AuthContext';

function GestionSistemas() {
    const { token } = useAuth();
    
    const [sistemas, setSistemas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [mensaje, setMensaje] = useState('');
    
    const [nombreSistema, setNombreSistema] = useState('');

    const [editingId, setEditingId] = useState(null);
    const [editingName, setEditingName] = useState('');

    const fetchSistemas = useCallback(async () => {
        setLoading(true);
        try {
            const headers = { 'Authorization': `Bearer ${token}` };
            // --- MODIFICADO ---
            const response = await fetch('/api/sistemas', { headers });
            if (!response.ok) { throw new Error('Error al cargar los sistemas.'); }
            const data = await response.json();
            setSistemas(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        if (token) {
            fetchSistemas();
        }
    }, [token, fetchSistemas]);

    const handleCrearSistema = async (e) => {
        e.preventDefault();
        setError('');
        setMensaje('');
        try {
            // --- MODIFICADO ---
            const response = await fetch('/api/sistemas', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre: nombreSistema }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Error al crear el sistema.');
            
            setMensaje('¡Sistema creado exitosamente!');
            setNombreSistema('');
            fetchSistemas();
        } catch (err) {
            setError(err.message);
        }
    };

    const handleActualizarSistema = async (e) => {
        e.preventDefault();
        setError('');
        setMensaje('');
        try {
            // --- MODIFICADO ---
            const response = await fetch(`/api/sistemas/${editingId}`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre: editingName }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Error al actualizar el sistema.');

            setMensaje('Sistema actualizado exitosamente.');
            setEditingId(null);
            setEditingName('');
            fetchSistemas();
        } catch (err) {
            setError(err.message);
        }
    };
    
    const handleDesactivarSistema = async (sistemaId) => {
        if (window.confirm('¿Estás seguro de que quieres desactivar este sistema?')) {
            setError('');
            setMensaje('');
            try {
                // --- MODIFICADO ---
                const response = await fetch(`/api/sistemas/${sistemaId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                const data = await response.json();
                if (!response.ok) throw new Error(data.message || 'Error al desactivar el sistema.');

                setMensaje('Sistema desactivado exitosamente.');
                fetchSistemas();
            } catch (err) {
                setError(err.message);
            }
        }
    };
    
    const startEditing = (sistema) => {
        setEditingId(sistema.id);
        setEditingName(sistema.nombre);
    };

    if (loading) return <div className="text-center mt-5"><div className="spinner-border" role="status"></div></div>;

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <h2 className="mb-4">Gestionar Sistemas</h2>
                    
                    {error && <div className="alert alert-danger">{error}</div>}
                    {mensaje && <div className="alert alert-success">{mensaje}</div>}

                    <div className="card shadow-sm mb-4">
                        <div className="card-body">
                            <h5 className="card-title">Crear Nuevo Sistema</h5>
                            <form onSubmit={handleCrearSistema}>
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Nombre del nuevo sistema" value={nombreSistema} onChange={(e) => setNombreSistema(e.target.value)} required />
                                    <button className="btn btn-primary" type="submit">Crear</button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="list-group">
                        {sistemas.map(sistema => (
                            <div key={sistema.id} className="list-group-item">
                                {editingId === sistema.id ? (
                                    <form onSubmit={handleActualizarSistema} className="d-flex gap-2">
                                        <input type="text" className="form-control" value={editingName} onChange={(e) => setEditingName(e.target.value)} required />
                                        <button type="submit" className="btn btn-success btn-sm">Guardar</button>
                                        <button type="button" onClick={() => setEditingId(null)} className="btn btn-secondary btn-sm">Cancelar</button>
                                    </form>
                                ) : (
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            {sistema.nombre}
                                            
                                        </div>
                                        <div>
                                            <span className={`badge rounded-pill ms-2 ${sistema.activo ? 'bg-success' : 'bg-secondary'}`}>
                                                {sistema.activo ? 'Activo' : 'Inactivo'}
                                            </span>
                                            <button onClick={() => startEditing(sistema)} className="btn btn-outline-primary btn-sm me-1">Editar</button>
                                            {sistema.activo && <button onClick={() => handleDesactivarSistema(sistema.id)} className="btn btn-outline-danger btn-sm">Desactivar</button>}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GestionSistemas;